import { Component, OnInit, ElementRef, Renderer2, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../base.component';

@Component({
    selector: '[resize-wrapper]',
    templateUrl: './resize-wrapper.component.html',
    styleUrls: ['./resize-wrapper.component.scss']
})
export class ResizeWrapperComponent extends BaseComponent implements OnInit {
    @Output() private widthChange = new EventEmitter<number>();
    /** Current width of the parent element */
    public width: number;
    /** Current location of the right side of the parent element */
    public right: number;
    /** Listener for pointer move events */
    public hold_listeners: { mouse: () => void, touch: () => void };
    /** Listener for pointer move events */
    public move_listener: () => void;
    /** Listener for pointer release events */
    public end_listener: () => void;

    @ViewChild('handle', { static: true }) public handle: ElementRef<HTMLDivElement>;

    constructor(private element: ElementRef<HTMLElement>, private renderer: Renderer2) {
        super();
    }

    public ngOnInit() {
        if (!this.element || !this.element.nativeElement || !this.handle || !this.handle.nativeElement) {
            return this.timeout('init', () => this.ngOnInit());
        }
        this.handleResize();
        this.hold_listeners = {
            mouse: this.renderer.listen(this.handle.nativeElement, 'mousedown', (e) => this.handleHold(e)),
            touch: this.renderer.listen(this.handle.nativeElement, 'touchstart', (e) => this.handleHold(e))
        };
    }

    public ngOnDestroy() {
        if (this.hold_listeners) {
            this.hold_listeners.mouse();
            this.hold_listeners.touch();
            delete this.hold_listeners;
        }
        this.handleEnd();
    }


    /**
     * Handle starting events for grab
     */
    public handleHold(event: TouchEvent | MouseEvent) {
        this.handleResize();
        const position = window.TouchEvent && event instanceof TouchEvent ? event.touches[0].clientX : (event as MouseEvent).clientX;
        this.right = position;
        // Add event handling for move and release events
        if (window.TouchEvent && event instanceof TouchEvent) {
            this.move_listener = this.renderer.listen('window', 'touchmove', (e) => this.handleMove(e));
            this.end_listener = this.renderer.listen('window', 'touchend', () => this.handleEnd());
        } else {
            this.move_listener = this.renderer.listen('window', 'mousemove', (e) => this.handleMove(e));
            this.end_listener = this.renderer.listen('window', 'mouseup', () => this.handleEnd());
        }
    }

    /**
     * Handle move events after grab start
     */
    public handleMove(event: TouchEvent | MouseEvent) {
        const position: number = window.TouchEvent && event instanceof TouchEvent ? event.touches[0].clientX : (event as MouseEvent).clientX;
        this.width = (this.width + (position - this.right)) || this.width;
        this.right = position;
        this.renderer.setStyle(this.element.nativeElement, 'width', `${this.width}px`);
        this.widthChange.emit(this.width);
    }

    /**
     * Handle release events for grab
     */
    public handleEnd() {
        if (this.move_listener) {
            this.move_listener();
            delete this.move_listener;
        }
        if (this.end_listener) {
            this.end_listener();
            delete this.end_listener;
        }
    }

    /**
     * Update parent element details after resizing the window
     */
    public handleResize() {
        const box = this.element.nativeElement.getBoundingClientRect();
        this.width = box.width;
        this.right = box.right;
    }

    /**
     * Reset the size of the element
     */
    public resetSize() {
        this.renderer.setStyle(this.element.nativeElement, 'width', '');
    }
}
